var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "layout-nft-mall-item",
    class: _vm.isMobile && 'layout-nft-mall-item-wap'
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };